import { render } from "./ModalBase.vue?vue&type=template&id=4531da5e&scoped=true"
import script from "./ModalBase.vue?vue&type=script&lang=js"
export * from "./ModalBase.vue?vue&type=script&lang=js"

import "./ModalBase.vue?vue&type=style&index=0&id=4531da5e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4531da5e"]])

export default __exports__